const app = window.app || {};
window.app = app;



// WEBPACK FOOTER //
// ./src/assets/js/_init.es6